module.exports = __webpack_public_path__ + "img/ticket.2cbf8a8.svg";